// Core packages
import { Component, Inject, OnInit } from '@angular/core';

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/shared/services/config.service';

// Custom packages

@Component({
  selector: 'app-sitisrl-dialog',
  templateUrl: './sitisrl-dialog.component.html',
  styleUrls: ['./sitisrl-dialog.component.scss']
})
export class SITISRLDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SITISRLDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public configService: ConfigService,

    private translateService: TranslateService,
  ) { }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit() {
  }

  /**
   * Handle click on close button
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
